'use es6';

import { __ANY_CTA } from 'customer-data-filters/converters/listSegClassic/ListSegConstants';
import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import getIn from 'transmute/getIn';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const ctaToOptions = memoize(ctaList => ctaList.map(cta => {
  const text = cta.get('label') ? cta.get('label') : I18n.text('customerDataFilters.FilterEditor.specialOptionValues.variationCta.input', {
    variantLabel: cta.get('variantLabel')
  });
  return {
    value: cta.get('guid'),
    text: cta.get('isDefault') ? I18n.text('customerDataFilters.FilterEditor.specialOptionValues.defaultCta.input') : text
  };
}).toArray());
class FilterOperatorCtaInput extends Component {
  constructor() {
    super();
    this.handleChange = ({
      target: {
        value: nextValue
      }
    }) => {
      const {
        fieldName,
        onChange,
        value
      } = this.props;
      onChange(syntheticEvent(value.set(fieldName, nextValue)));
    };
    this.handleOptionsChange = cta => {
      if (isResolved(cta)) {
        const ctaInfo = cta.referencedObject.get('ctaInfo');
        const options = ctaInfo && ctaInfo.size > 0 ? ctaToOptions(ctaInfo) : [];
        this.setState({
          loading: false,
          options
        });
      }
    };
    this.state = {
      loading: true,
      options: []
    };
    this.referenceCtaAtom = null;
  }
  componentDidMount() {
    const {
      fieldName,
      onChange,
      resolver,
      value
    } = this.props;
    const field = getIn(['field', 'name'], value) || '';
    if (resolver && resolver.byId && field) {
      this.referenceCtaAtom = resolver.byId(field);
      watch(this.referenceCtaAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceCtaAtom));
    }
    onChange(syntheticEvent(value.set(fieldName, value.get(fieldName) || __ANY_CTA)));
  }
  componentWillUnmount() {
    if (this.referenceCtaAtom) {
      unwatch(this.referenceCtaAtom, this.handleOptionsChange);
    }
  }
  focus() {
    this.input.focus();
  }
  getOptions() {
    return [{
      text: I18n.text('customerDataFilters.FilterEditor.specialOptionValues.anyCta.input'),
      value: __ANY_CTA
    }, ...this.state.options];
  }
  render() {
    const {
      className,
      fieldName,
      value
    } = this.props;
    const {
      loading
    } = this.state;
    const error = loading ? false : undefined;
    return /*#__PURE__*/_jsx(UISelect, {
      className: className,
      defaultValue: __ANY_CTA,
      error: error,
      onChange: this.handleChange,
      options: this.getOptions(),
      ref: component => this.input = component,
      value: value.get(fieldName)
    });
  }
}
FilterOperatorCtaInput.defaultProps = {
  fieldName: 'value'
};
FilterOperatorCtaInput.propTypes = {
  className: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  resolver: ReferenceResolverType,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorCtaInput;